import {createTheme} from "@material-ui/core/styles";
const themeObj = {
  palette: {
    primary: {
      main: "#8a8c8f",
    },
    secondary: {
      main: "#58595b",
    },
  },
  typography: {
    fontFamily: "Averta Regular",
  },

  overrides: {
    MuiTypography: {
      body1: {
        fontFamily: "Averta Regular",
      },
    },
    MuiFormLabel: {
      root: {
        marginBottom: "15px",
        color: "#000000",
      },
    },
    MuiFormControl: {
      root: {
        marginBottom: ".8rem",
      },
    },
    MuiFormControlLabel: {
      root: {
        color: "#8a8c8f",
      },
    },
    MuiButton: {
      root: {
        fontFamily: '"Averta Bold", sans-serif',
        fontSize: "16px",
        padding: "8px 40px",
        borderRadius: "6px",
      },
    },
    MuiMenuItem: {
      root: {
        fontFamily: '"neue-haas-unica", sans-serif !important',
        fontWeight: "900",
        textTransform: "uppercase",
        "& a": {
          textDecoration: "none",
        },
      },
    },
    MuiPaper: {
      rounded: {
        borderRadius: "0",
      },
    },
  },
};
const theme = createTheme(themeObj);
export {theme, themeObj};
